import {Moment} from 'moment-timezone'

export type ParsableTime = string | Date | Moment | number
export interface Timespan<T extends ParsableTime = ParsableTime> {
  start: T
  end: T
}

export type Range<T> = [start: T, end: T]
export type NumberRange = Range<number>
export type ParsableTimeRange<T extends ParsableTime = ParsableTime> = Range<T>
export type MomentRange = ParsableTimeRange<Moment>

export const isStartOfDay = (datetime: Moment) => datetime.isSame(datetime.clone().startOf('day'))
